import { GetDiscountCodesForAdminState } from './getDiscountCodesForAdmin.types'

const initialState: GetDiscountCodesForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
